import { createSelector } from 'reselect';
import { isBlank } from 'lib/string';
import pagePayloadSelector from './pagePayload';

export default createSelector(pagePayloadSelector, pagePayload => !isBlank(pagePayload.Id));
